import { $api } from "../../../../services/request.config";
import { reportEntityAction } from "../../../Documents/EmployeDocuments/reportEntity.action";

export const documentSignigRejectThunkAction = (data, comment, input, props) => async (dispatch) => {
    try {
        console.log(data);
        props.setLoader(true);
        if (comment.isUserCommentRequired) {
            const response = await $api.post("v2/directum/document/signing/reject", {
                entityId: data.entityId,
                entityType: data.entityType,
                documentId: data.documentId,
                workerId: data.workerId,
                comment: input.text,
                entityName: data.entityName,

            });
            if (response.status === 204) {
                dispatch(reportEntityAction(data.entityId));
                props.setLoader(false);
                props.setRequestStatus(data.entityType === 2 ? `${data.entityName} отклонено` : "сообщение об ошибке отправлено");
            }
        } else {
            const response = await $api.post("v2/directum/document/signing/reject", {
                entityId: data.entityId,
                entityType: data.entityType,
                documentId: data.documentId,
                workerId: data.workerId,
                comment: comment.comment,
                entityName: data.entityName,

            });
            if (response.status === 204) {
                dispatch(reportEntityAction(data.entityId));
                props.setLoader(false);
                props.setRequestStatus(data.entityType === 2 ? `${data.entityName} отклонено` : "сообщение об ошибке отправлено");
            }
        }
    } catch (e) {
        props.setLoader(false);
        props.setRequestStatus("не удалось отправить сообщение об ошибке");
    }
};
